import { render, staticRenderFns } from "./ModalSpendingFee.vue?vue&type=template&id=b8571f08&scoped=true&"
import script from "./ModalSpendingFee.vue?vue&type=script&lang=js&"
export * from "./ModalSpendingFee.vue?vue&type=script&lang=js&"
import style0 from "./ModalSpendingFee.vue?vue&type=style&index=0&id=b8571f08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8571f08",
  null
  
)

export default component.exports